// LeaveFilters.jsx
import { Search } from 'lucide-react';

export default function LeaveFilters({ filter, setFilter, searchQuery, setSearchQuery }) {
  return (
    <div className="backdrop-blur-sm bg-white/70 rounded-xl p-4 shadow-md flex flex-col md:flex-row md:items-center gap-4">
      <div className="inline-flex p-1 bg-gray-100 rounded-lg">
        {['All', 'Pending', 'Approved', 'Rejected'].map(status => (
          <button
            key={status}
            className={`px-4 py-2 text-sm font-medium rounded-md transition-colors ${
              filter === status.toLowerCase()
                ? 'bg-white shadow text-indigo-600'
                : 'text-gray-600 hover:text-gray-800'
            }`}
            onClick={() => setFilter(status.toLowerCase())}
          >
            {status}
          </button>
        ))}
      </div>
      <div className="flex-1">
        <div className="bg-white/70 backdrop-blur-sm rounded-lg flex items-center px-3 border border-gray-200">
          <Search className="h-5 w-5 text-gray-400" />
          <input
            placeholder="Search requests..."
            className="bg-transparent py-2 px-3 w-full focus:outline-none"
            value={searchQuery}
            onChange={e => setSearchQuery(e.target.value)}
          />
        </div>
      </div>
    </div>
  );
}
